'use strict';

angular.module('buyers')
.directive('openHomeRegisteration', ['$rootScope', 'BuyerService', function($rootScope, BuyerService) {
    return {
        templateUrl : "partials/open-home-registeration.html",
        restrict: 'E', // attribute
        scope: {
            'back': '&onBack',
            'openhome':'=',
            'property':'='
        },
        link : function (scope, element, attrs) {
            var currentUser = $rootScope.currentUser;
            scope.registeration = {
                name: currentUser.name,
                email: currentUser.info.email,
                phone: currentUser.info.mobile,
            };
            
            element.find('.register').on('click', function() {
                $rootScope.loading = true;
                BuyerService.registerForOpenHome(scope.registeration, scope.openhome, scope.property)
                .then(function(data){
                    alert('You have been registered for open home.');
                })
                .catch(function(err){
                    console.log(err);
                })
                .finally(function(data){
                    $rootScope.loading = false;
                });
            });
        }
    };
}]);